module.exports = ol.geom.Polygon;